export enum productsActionType {
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_PRODUCT = 'SET_PRODUCT',
}
